import React from 'react';
import Swiper from 'react-id-swiper';
import './TrailersSwiper.scss';

class TrailersSwiper extends React.Component {
  render() {
    const params = {
      centeredSlides: true,
      slidesPerView: 3,
      loop: true,
      rebuildOnUpdate: true,
      spaceBetween: 15,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        900: {
          slidesPerView: 2,
        },
        550: {
          slidesPerView: 1,
        },
      },
    };

    let slides = this.props.sources.map((el, i) => {
      return (
        <iframe
          className="trailer-iframe"
          src={el.trailer_src}
          key={el.trailer_id}
          title={el.trailer_id}
          frameBorder="0"
        />
      );
    });

    return (
      <>
        <h3 className="slider__title">Trailers</h3>
        <Swiper {...params}>{slides}</Swiper>
        <hr className="swiper-divider" />
      </>
    );
  }
}

export default TrailersSwiper;
